var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "modal-card modal-card--xxl" }, [
    _c("header", { staticClass: "modal-card-head" }, [
      _c("p", { staticClass: "modal-card-title" }, [
        _vm._v(" Select Multiple Products "),
      ]),
      _c(
        "a",
        {
          staticClass: "close-modal",
          attrs: { "aria-label": "close" },
          on: {
            click: function ($event) {
              return _vm.closeModal()
            },
          },
        },
        [_c("i", { staticClass: "material-icons" }, [_vm._v("close")])]
      ),
    ]),
    _c("section", { staticClass: "modal-card-body" }, [
      _c("div", { staticClass: "multi-product-body-row" }, [
        _c("div", [
          _c("div", { staticClass: "select-container" }, [
            _c("div", { staticClass: "select-sticky" }, [
              _c("div", { staticClass: "search-container" }, [
                _c("i", { staticClass: "material-icons search-icon" }, [
                  _vm._v("search"),
                ]),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.filter,
                      expression: "filter",
                    },
                  ],
                  staticClass: "input",
                  attrs: { type: "text", placeholder: "Search products..." },
                  domProps: { value: _vm.filter },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.filter = $event.target.value
                    },
                  },
                }),
                _vm.filter && _vm.filter.length
                  ? _c(
                      "i",
                      {
                        staticClass: "material-icons close-icon",
                        on: {
                          click: function ($event) {
                            _vm.filter = ""
                          },
                        },
                      },
                      [_vm._v("close")]
                    )
                  : _vm._e(),
              ]),
              _c("div", { staticClass: "toggle-row" }, [
                _c(
                  "span",
                  {
                    staticClass: "pseudo-link",
                    on: {
                      click: function ($event) {
                        return _vm.selectAll()
                      },
                    },
                  },
                  [
                    _vm._v("Select "),
                    !_vm.filter.length
                      ? _c("span", [_vm._v("all")])
                      : _c("span", [_vm._v("visible")]),
                  ]
                ),
                _vm._v("/ "),
                _c(
                  "span",
                  {
                    staticClass: "pseudo-link",
                    on: {
                      click: function ($event) {
                        return _vm.deselectAll()
                      },
                    },
                  },
                  [
                    _vm._v("Deselect "),
                    !_vm.filter.length
                      ? _c("span", [_vm._v("all")])
                      : _c("span", [_vm._v("visible")]),
                  ]
                ),
                _vm._v("/ "),
                _c(
                  "span",
                  {
                    staticClass: "pseudo-link",
                    on: {
                      click: function ($event) {
                        return _vm.toggleAll()
                      },
                    },
                  },
                  [
                    _vm._v("Toggle "),
                    !_vm.filter.length
                      ? _c("span", [_vm._v("all")])
                      : _c("span", [_vm._v("visible")]),
                  ]
                ),
              ]),
            ]),
            _c("div", { staticClass: "select-scrollable" }, [
              _c(
                "div",
                {
                  staticClass: "select-inner",
                  class: {
                    "select-inner--empty": !_vm.productsArrayFiltered.length,
                  },
                },
                [
                  !_vm.productsArrayFiltered.length
                    ? _c("div", { staticClass: "select-all-empty" }, [
                        _vm._v(" Empty "),
                      ])
                    : _vm._e(),
                  _c("ProductTreeLevel", {
                    attrs: {
                      items: _vm.productsArrayFiltered,
                      internalSelectionState: _vm.internalSelectionState,
                      filter: _vm.filter,
                    },
                    on: {
                      select: function ($event) {
                        return _vm.selectClick($event)
                      },
                    },
                  }),
                ],
                1
              ),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "right-col" }, [
          _c("h5", [_vm._v(" Currently Selected ")]),
          _vm.selectedProductsForRightCol &&
          _vm.selectedProductsForRightCol.length
            ? _c("div", { staticClass: "remove-all" }, [
                _c(
                  "span",
                  {
                    staticClass: "pseudo-link",
                    on: {
                      click: function ($event) {
                        return _vm.removeAll()
                      },
                    },
                  },
                  [_vm._v(" Remove all ")]
                ),
              ])
            : _vm._e(),
          _vm.selectedProductsForRightCol &&
          _vm.selectedProductsForRightCol.length
            ? _c(
                "div",
                { staticClass: "selected-list" },
                _vm._l(_vm.selectedProductsForRightCol, function (prod, id) {
                  return _c("div", { key: id }, [
                    _c("div", { staticClass: "selected-item__title" }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            prod.displayHierarchy || prod.display || prod.id
                          ) +
                          " "
                      ),
                    ]),
                    prod.displayHierarchy
                      ? _c("div", { staticClass: "selected-item__detail" }, [
                          _vm._v(
                            " " +
                              _vm._s(_vm.returnSelectedItemDetail(prod)) +
                              " "
                          ),
                        ])
                      : _vm._e(),
                    _c(
                      "div",
                      {
                        staticClass: "remove-selected-item",
                        on: {
                          click: function ($event) {
                            return _vm.selectClick(prod, "Unselected")
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("close"),
                        ]),
                      ]
                    ),
                  ])
                }),
                0
              )
            : _c("div", { staticClass: "selected-list--empty" }, [
                _vm._v(" No products selected "),
              ]),
        ]),
      ]),
      _c("div", { staticClass: "buttons-row" }, [
        _c(
          "button",
          {
            staticClass: "button button-secondary button-outline button-medium",
            on: {
              click: function ($event) {
                return _vm.closeModal()
              },
            },
          },
          [_vm._v(" Cancel ")]
        ),
        _c(
          "button",
          {
            staticClass: "button button-primary button-medium",
            on: {
              click: function ($event) {
                return _vm.applyChanges()
              },
            },
          },
          [_vm._v(" Apply ")]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }